'use strict';
var defineWellKnownSymbol = require('../internals/well-known-symbol-define');

// `Symbol.asyncDispose` well-known symbol
// https://github.com/tc39/proposal-async-explicit-resource-management
defineWellKnownSymbol('asyncDispose');



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/modules/esnext.symbol.async-dispose.js
// module id = 740
// module chunks = 13